import { Injectable, Injector } from '@angular/core';
import { InterfaceNameValue } from '@common/interfaces/issueTypeInterface';
import {
  AnyInterfaceDataQuery,
  AnyInterfaceDataService,
  getRegisteredInterfaceNames,
  getInterfaceStoreNamesByInterfaceName,
  interfaceDataQueryToken,
  interfaceDataServiceToken,
  isRegisteredInterfaceName,
} from './interfaceDataRegistry';

/**
 * DI facade over interfaceDataRegistry: resolves the query/service of an issue interface by
 * InterfaceName through the memoized InjectionTokens, so single entries stay overridable in
 * TestBed. Unknown names throw (see the token factory) — meta interfaces ('_meta_*') are NOT
 * handled here: callers dispatch them to MetaInterfaceServiceProvider before calling.
 */
@Injectable({
  providedIn: 'root'
})
export class InterfaceDataResolver {
  constructor(private injector: Injector) {}

  getQuery(interfaceName: InterfaceNameValue): AnyInterfaceDataQuery {
    return this.injector.get(interfaceDataQueryToken(interfaceName));
  }

  getService(interfaceName: InterfaceNameValue): AnyInterfaceDataService {
    return this.injector.get(interfaceDataServiceToken(interfaceName));
  }

  getAllServices(): AnyInterfaceDataService[] {
    return getRegisteredInterfaceNames().map((interfaceName) => this.getService(interfaceName));
  }

  isRegistered(interfaceName: InterfaceNameValue): boolean {
    return isRegisteredInterfaceName(interfaceName);
  }

  interfaceNames(): readonly InterfaceNameValue[] {
    return getRegisteredInterfaceNames();
  }

  /** interfaceName -> Akita store name (static metadata, no instantiation). */
  storeNamesByInterfaceName(): Record<string, string> {
    return getInterfaceStoreNamesByInterfaceName();
  }
}
